import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAddressCard,
				 faCertificate,
				 faClipboardList,
				 faSignInAlt,
				 faSignOutAlt,
				 faKey,
				 faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faRegStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/**
 * Add Font Awesome icons to Vue
 */
library.add(faAddressCard, faClipboardList, faCertificate, faSignInAlt, faSignOutAlt, faKey, faStar, faRegStar);
Vue.component('fa-icon', FontAwesomeIcon);

/**
 *
 */
Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
